<template>
      <iframe src="https://www.entertainment-plus.net/affiliate_1663/cancun-airport-transfers/puerto-cancun"></iframe>
  <!--https://www.entertainment-plus.net/affiliate_1545/cancun-airport-transfers/iberostar-golf-club -->
</template>
<style scoped>
   
</style>

<script>



export default {
  name: 'transportacion',
  components: {
     
  },
  props:[],
  data(){
     return {
      
     }
  },
  methods:{
    
  },
  computed:{
     
  },
  beforeMount: function() {
     
   
            

  },
  mounted(){
     document.querySelectorAll("iframe")[0].style="height: 100vh !important;  width:100vw;";
    
  },
  created(){
   
  }
  
}
</script>